/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { ref } from '@vue/composition-api';
import TreeItem from '../tree-item.js';
import { privateKey } from '../../_common/js/tree/tree-node.js';
import useTreeEvents from './useTreeEvents.js';
import '../../config-provider/config-receiver.js';
import 'vue';
import 'lodash/mergeWith';
import '../../config-provider/context.js';
import 'lodash/merge';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import './useTreeItem.js';
import '@babel/runtime/helpers/defineProperty';
import '../../hooks/useConfig.js';
import '../../config-provider/useConfig.js';
import '../../hooks/useLazyLoad.js';
import '../../_common/js/utils/observe.js';
import './useItemEvents.js';
import './useRenderIcon.js';
import 'tdesign-icons-vue';
import '../../hooks/useGlobalIcon.js';
import '../../loading/index.js';
import '../../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../../loading/plugin.js';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isNumber';
import 'lodash/isArray';
import '../../utils/mixins.js';
import '../../utils/dom.js';
import 'raf';
import '../../utils/easing.js';
import '../../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../config.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../loading/type.js';
import '../util.js';
import './useRenderLabel.js';
import '../../_chunks/dep-1461d230.js';
import 'lodash/isBoolean';
import '../../checkbox/index.js';
import '../../checkbox/group.js';
import 'lodash/intersection';
import '../../checkbox/checkbox.js';
import '../../checkbox/props.js';
import '../../hooks/index.js';
import '../../hooks/slots.js';
import '../../hooks/useCommonClassName.js';
import '../../hooks/useDefaultValue.js';
import '../../hooks/useDestroyOnClose.js';
import '../../hooks/useElementLazyRender.js';
import '../../hooks/useFormDisabled.js';
import '../../hooks/useResizeObserver.js';
import '../../hooks/useVirtualScrollNew.js';
import '../../hooks/useVModel.js';
import '../../hooks/useImagePreviewUrl.js';
import '../../_common/js/upload/utils.js';
import '../../_common/js/log/log.js';
import '../../checkbox/constants.js';
import '../../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../../checkbox/hooks/useKeyboardEvent.js';
import '../../checkbox/checkbox-group-props.js';
import '../../checkbox/type.js';
import './useRenderLine.js';
import './useRenderOperations.js';
import './useDraggable.js';
import 'lodash/throttle';
import '../../utils/ripple.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import 'lodash/isFunction';
import 'lodash/uniqueId';
import 'lodash/isNil';
import 'lodash/get';
import '../../_common/js/tree/tree-node-model.js';
import 'lodash/omit';
import '../../_common/js/log/index.js';
import './useTreeAction.js';

function useTreeNodes(props, context, state) {
  var treeState = state;
  var store = treeState.store,
    scope = treeState.scope,
    nodes = treeState.nodes,
    virtualConfig = treeState.virtualConfig;
  var _useTreeEvents = useTreeEvents(props, context, state),
    handleClick = _useTreeEvents.handleClick,
    handleChange = _useTreeEvents.handleChange;
  var nodesEmpty = ref(false);
  var cacheMap = /* @__PURE__ */new Map();
  var refresh = function refresh() {
    var list = [];
    var allNodes = store.getNodes();
    var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
    if (isVirtual) {
      list = virtualConfig.visibleData.value;
      nodesEmpty.value = list.length <= 0;
    } else {
      var hasVisibleNode = false;
      allNodes.forEach(function (node) {
        if (node.visible) {
          hasVisibleNode = true;
          cacheMap.set(node.value, node.value);
        }
        if (cacheMap.get(node.value)) {
          list.push(node);
        }
      });
      nodesEmpty.value = !hasVisibleNode;
      cacheMap.forEach(function (value) {
        if (!store.getNode(value)) {
          cacheMap["delete"](value);
        }
      });
    }
    nodes.value = list;
  };
  var renderItem = function renderItem(h, node, index) {
    var expandOnClickNode = props.expandOnClickNode;
    var rowIndex = node.__VIRTUAL_SCROLL_INDEX || index;
    var treeItem = h(TreeItem, {
      "key": node[privateKey],
      "attrs": {
        "rowIndex": rowIndex,
        "node": node,
        "treeScope": scope,
        "expandOnClickNode": expandOnClickNode
      },
      "on": {
        "click": handleClick,
        "change": handleChange
      }
    });
    return treeItem;
  };
  var renderTreeNodes = function renderTreeNodes(h) {
    var treeNodeViews = nodes.value.map(function (node, index) {
      return renderItem(h, node, index);
    });
    return treeNodeViews;
  };
  refresh();
  store.emitter.on("update", refresh);
  return {
    refresh: refresh,
    nodesEmpty: nodesEmpty,
    renderTreeNodes: renderTreeNodes
  };
}

export { useTreeNodes as default };
//# sourceMappingURL=useTreeNodes.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/tree/hooks/useTreeNodes.js
// module id = null
// module chunks = 